var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridLayout',{staticClass:"header",attrs:{"rows":"56","columns":"*, auto"}},[_c('VxpLabel',{staticClass:"header__title font-h2-24",attrs:{"row":"0","col":"0","text":_vm.texts.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }